<template>
  <label
    class="label"
    :for="id"
    v-text="text"
  />
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
  @import "../../styles/shared/shared";
  .label {
    display: block;
    font-size: $font-size-base;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
</style>
